var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-result',{attrs:{"icon":"success","title":"成功!","subTitle":"提交成功"}},[_c('template',{slot:"extra"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.toIndex}},[_vm._v("返回")])],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }